export default __webpack_public_path__ + "static/TaberTrip-55aec5fd4f1836ffe82f5f972f2a898a.jpg";